import { cx } from "class-variance-authority";

// Not `tailwind-merge` directly: the stock config deletes a `leading-*` that a
// later `text-<size>` follows, which is a Tailwind v3 rule that no longer holds.
// See packages/utils/src/tailwind/index.ts.
import { twMerge } from "@ergon-ai/utils/tailwind";

const cn = (...inputs: Parameters<typeof cx>) => twMerge(cx(inputs));

const uuid = () => {
  // Check if crypto and getRandomValues are available
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.getRandomValues === "function"
  ) {
    // Generate UUID4
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);

    // Set the version (UUIDv4) and variant bits according to the standard
    array[6] = array[6] ? array[6] & 0x0f : 0x40; // Set bits 4-7 to 0100 for version 4
    array[8] = array[8] ? array[8] & 0x3f : 0x80; // Set bits 6-7 to 10 for variant

    // Convert the array to the UUID format
    return Array.from(array)
      .map((byte, index) => {
        let hex = byte.toString(16).padStart(2, "0");
        // Insert hyphens at the correct positions
        if (index === 4 || index === 6 || index === 8 || index === 10) {
          hex = "-" + hex;
        }
        return hex;
      })
      .join("");
  }

  // Fallback: simple counter-based UUID generation
  return Math.random().toString(36).substring(2, 9);
};

export { cn, uuid };
